import EventCard from '@/components/organisms/eventCard'

const EventContainer = ({ events }) => {
  const base = 'relative w-full grid grid-cols-1 lg:grid-cols-3 gap-[20px] lg:gap-[40px] mt-mediumMobile lg:mt-mediumDesktop'
  
  return (
    <div className={base}>
      {events.map((data, id) => (
        <EventCard
          key={id}
          thumbnail={data.thumbnail}
          title={data.title}
          slug={data.slug}
          categoryName={data.category.name}
        />
      ))}
    </div>
  )
}

export default EventContainer
